module.exports = __webpack_public_path__ + "img/hr-fast-transport-belt.5f28c13a.png";